export const SIDEBAR_COLLAPSIBLE_MODE = "icon";
